import { styled } from 'styled-components';

export const InfiniteScrollContainer = styled.div`
    width: 100%;
    overflow-y: scroll;
    height: 60vh;
`;
